<template minapp='mpx' xlang='wxml'>
  <contact-dialog
    show="{{show}}"
    title="温馨提示"
    cancelText="我知道了"
    content="儿童不能单独出行，请选择一名成年乘客同行"
    bind:cancel="cancelContactDialog"
    btnStyle="fill"
  ></contact-dialog>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    componentName: 'ChildDialog',
    props: {
      show: {
        type: Boolean,
        value: false
      }
    },
    methods: {
      cancelContactDialog() {
        this.$trigger('cancel')
      },
      confirmContactDialog() {
        this.$trigger('confirm')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'contact-dialog': './index'
    }
  }
</script>

